import { Component, OnInit } from "@angular/core";
import { RegistrationService } from "../../services/registration/registration.service";
import { User } from "../../interfaces/user";
import { ActivatedRoute, Router } from "@angular/router";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { environment } from "../../../environments/environment";
import { MzToastService } from "ng2-materialize";

@Component({
  selector: "app-registration",
  templateUrl: "./registration.component.html",
  styleUrls: ["./registration.component.scss"],
})
export class RegistrationComponent implements OnInit {
  env: any = environment;
  user = { password: "" } as User;
  confirmPassword = "" as string;
  registrationForm: FormGroup;
  error: string;
  loading: boolean = false;
  userErrorMessage: string;
  confirmTerms: boolean = false;
  showBorderForConfirmTerms: boolean = false;

  constructor(
    private registerService: RegistrationService,
    private router: Router,
    private toastService: MzToastService,
    private route: ActivatedRoute
  ) {}

  errorMessages = {
    email: {
      required: "Bitte gib eine gültige E-Mail-Adresse an.",
      pattern: "Das E-Mail-Format ist ungültig.",
    },
    firstName: {
      required: "Bitte gib Deinen Vornamen an.",
    },
    lastName: {
      required: "Bitte gib Deinen Nachnamen an.",
    },
    password: {
      required: "Bitte gib ein Passwort an.",
      pattern: "Das Passwort muss mindestens 6 Zeichen lang sein.",
      validateEqual: "Die Passwörter müssen übereinstimmen.",
    },
    confirmPassword: {
      required: "Bitte gib ein Passwort an.",
      pattern: "Das Passwort muss mindestens 6 Zeichen lang sein.",
      validateEqual: "Die Passwörter müssen übereinstimmen.",
    },
    confirmTerms: {
      required: "Bitte bestätige die Nutzungsbedingungen.",
    },
  };

  ngOnInit() {
    this.route.params.subscribe((params: { token: string }) => {
      this.user.invitationToken = params.token;
    });

    this.registrationForm = new FormGroup({
      email: new FormControl(this.user.email, {
        validators: Validators.required,
        updateOn: "blur",
      }),
      firstName: new FormControl(this.user.firstName, Validators.required),
      lastName: new FormControl(this.user.lastName, Validators.required),
      password: new FormControl(this.user.password, Validators.required),
      confirmPassword: new FormControl(
        this.confirmPassword,
        Validators.required
      ),
      terms: new FormControl(this.confirmTerms, Validators.required),
    });

    setTimeout(() => {
      $("#firstName").focus();
      $("#firstName").select();
    }, 100);
  }

  register() {
    this.showBorderForConfirmTerms = false;

    if (this.registrationForm.valid) {
      this.loading = true;
      this.registerService
        .register(this.user)
        .then(() => {
          this.loading = false;
          // this.toastService.show(' Eine E-Mail zum Aktivieren des Accounts wurde an: ' + this.user.email + ' verschickt.', 4000, 'confirm-toast');
          this.userErrorMessage = null;
          this.router.navigate(["/login"], {
            queryParams: {
              email: this.user.email,
              registerNotify:
                "Eine E-Mail zum Aktivieren des Accounts wurde an: " +
                this.user.email +
                " verschickt.",
            },
          });
        })
        .catch((res) => {
          this.loading = false;
          this.error = res.error.message;

          if (res.error.message.includes("Email")) {
            this.userErrorMessage = "Diese E-Mail-Adresse ist schon vergeben.";
          } else if (res.error.message.indexOf("Entity") !== -1) {
            this.userErrorMessage = "Bitte überprüfe Deine Eingaben.";
          } else {
            this.userErrorMessage = res.error.message;
          }
        });
    } else {
      if (this.confirmTerms === false) {
        this.userErrorMessage = this.errorMessages.confirmTerms.required;
        this.showBorderForConfirmTerms = true;
      } else {
        this.userErrorMessage = "Bitte überprüfe Deine Eingaben.";
      }
    }
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/registration/registration.component.ts